<template>
    <div id="usuarioInvoicesStripe">
        <div class="text-center mt-5 mb-5" v-if="!isLoaded">
            <b-spinner label="Loading..."></b-spinner>
        </div>
        <b-card no-body no-gutters v-else-if="invoices.length">
            <template #header>Mis ordenes de pago</template>
            <b-table responsive hover
                @row-clicked="viewInvoice"
                :items="invoices" 
                :fields="fields">
                <template #cell(customer_name)="data">
                    <div>
                        <div>{{ data.item.customer_name }}</div>
                        <small class="text-muted">{{ data.item.customer_email }}</small>
                    </div>
                </template>
                <template #cell(id)="data">
                    <div>
                        <code style="font-size: smaller;">{{ data.item.id }}</code>
                    </div>
                </template>
                <template #cell(_)="data">
                    <b-button @click="viewInvoice(data.item.invoice_pdf)" variant="primary">Ver Detalle</b-button>
                </template>
            </b-table>
        </b-card>
        <b-jumbotron v-else>
            <template #header>
                <h1>No se encontraron órdenes de pago</h1>
            </template>
            <p class="lead">
                De momento no tienes historial de órdenes de pago.
            </p>
        </b-jumbotron>
    </div>
</template>

<script>
const name = 'usuarioInvoicesStripe';
import axios from 'axios';
import { BSpinner, BCard, BCardGroup, BCardTitle, BCardText, BJumbotron } from 'bootstrap-vue';
    
export default {
    name,
    components: {
        BSpinner,
        BCard,
        BCardGroup,
        BCardTitle,
        BCardText,
        BJumbotron
    },
    data() {
        return {
            isLoaded: false,
            invoices: [
                // {
                //     "id": "in_1QwvQYQP5E7ERO2naxMmzQXl",
                //     "object": "invoice",
                //     "account_country": "MX",
                //     "account_name": "BlackFon",
                //     "account_tax_ids": null,
                //     "amount_due": 24900,
                //     "amount_paid": 24900,
                //     "amount_remaining": 0,
                //     "amount_shipping": 0,
                //     "application": null,
                //     "application_fee_amount": null,
                //     "attempt_count": 1,
                //     "attempted": true,
                //     "auto_advance": false,
                //     "automatic_tax": {
                //         "disabled_reason": null,
                //         "enabled": false,
                //         "liability": null,
                //         "status": null
                //     },
                //     "automatically_finalizes_at": null,
                //     "billing_reason": "subscription_create",
                //     "charge": "ch_3QwvQYQP5E7ERO2n1X1jUnPf",
                //     "collection_method": "charge_automatically",
                //     "created": 1740617894,
                //     "currency": "mxn",
                //     "custom_fields": null,
                //     "customer": "cus_RnXrnqKijjrE8y",
                //     "customer_address": null,
                //     "customer_email": "yo+feb6@daniellepe.com",
                //     "customer_name": "Daniel Lepe",
                //     "customer_phone": "(331) 587-4260",
                //     "customer_shipping": null,
                //     "customer_tax_exempt": "none",
                //     "customer_tax_ids": [],
                //     "default_payment_method": null,
                //     "default_source": null,
                //     "default_tax_rates": [],
                //     "description": null,
                //     "discount": null,
                //     "discounts": [],
                //     "due_date": null,
                //     "effective_at": 1740617894,
                //     "ending_balance": 0,
                //     "footer": null,
                //     "from_invoice": null,
                //     "hosted_invoice_url": "https://invoice.stripe.com/i/acct_1Q8OBwQP5E7ERO2n/test_YWNjdF8xUThPQndRUDVFN0VSTzJuLF9ScWNmM3liRUw5WkZvUWhRMVZINWp5bXRnRjFQTFo2LDEzMTMxNjA1NQ02000AcDe4uM?s=ap",
                //     "invoice_pdf": "https://pay.stripe.com/invoice/acct_1Q8OBwQP5E7ERO2n/test_YWNjdF8xUThPQndRUDVFN0VSTzJuLF9ScWNmM3liRUw5WkZvUWhRMVZINWp5bXRnRjFQTFo2LDEzMTMxNjA1NQ02000AcDe4uM/pdf?s=ap",
                //     "issuer": {
                //         "type": "self"
                //     },
                //     "last_finalization_error": null,
                //     "latest_revision": null,
                //     "lines": {
                //         "object": "list",
                //         "data": [
                //             {
                //                 "id": "il_1QwvQYQP5E7ERO2n000AiPfO",
                //                 "object": "line_item",
                //                 "amount": 24900,
                //                 "amount_excluding_tax": 24900,
                //                 "currency": "mxn",
                //                 "description": "1 × Black 5G (at $249.00 / month)",
                //                 "discount_amounts": [],
                //                 "discountable": true,
                //                 "discounts": [],
                //                 "invoice": "in_1QwvQYQP5E7ERO2naxMmzQXl",
                //                 "livemode": false,
                //                 "metadata": [],
                //                 "period": {
                //                     "end": 1743037094,
                //                     "start": 1740617894
                //                 },
                //                 "plan": {
                //                     "id": "price_1Q8OLpQP5E7ERO2na3IH3GHs",
                //                     "object": "plan",
                //                     "active": true,
                //                     "aggregate_usage": null,
                //                     "amount": 24900,
                //                     "amount_decimal": "24900",
                //                     "billing_scheme": "per_unit",
                //                     "created": 1728574349,
                //                     "currency": "mxn",
                //                     "interval": "month",
                //                     "interval_count": 1,
                //                     "livemode": false,
                //                     "metadata": [],
                //                     "meter": null,
                //                     "nickname": null,
                //                     "product": "prod_R0PAj1dVlCYBPG",
                //                     "tiers_mode": null,
                //                     "transform_usage": null,
                //                     "trial_period_days": null,
                //                     "usage_type": "licensed"
                //                 },
                //                 "pretax_credit_amounts": [],
                //                 "price": {
                //                     "id": "price_1Q8OLpQP5E7ERO2na3IH3GHs",
                //                     "object": "price",
                //                     "active": true,
                //                     "billing_scheme": "per_unit",
                //                     "created": 1728574349,
                //                     "currency": "mxn",
                //                     "custom_unit_amount": null,
                //                     "livemode": false,
                //                     "lookup_key": null,
                //                     "metadata": [],
                //                     "nickname": null,
                //                     "product": "prod_R0PAj1dVlCYBPG",
                //                     "recurring": {
                //                         "aggregate_usage": null,
                //                         "interval": "month",
                //                         "interval_count": 1,
                //                         "meter": null,
                //                         "trial_period_days": null,
                //                         "usage_type": "licensed"
                //                     },
                //                     "tax_behavior": "unspecified",
                //                     "tiers_mode": null,
                //                     "transform_quantity": null,
                //                     "type": "recurring",
                //                     "unit_amount": 24900,
                //                     "unit_amount_decimal": "24900"
                //                 },
                //                 "proration": false,
                //                 "proration_details": {
                //                     "credited_items": null
                //                 },
                //                 "quantity": 1,
                //                 "subscription": "sub_1QwvQYQP5E7ERO2n1SnOimja",
                //                 "subscription_item": "si_RqcfeQrVHTBzJi",
                //                 "tax_amounts": [],
                //                 "tax_rates": [],
                //                 "type": "subscription",
                //                 "unit_amount_excluding_tax": "24900"
                //             }
                //         ],
                //         "has_more": false,
                //         "total_count": 1,
                //         "url": "/v1/invoices/in_1QwvQYQP5E7ERO2naxMmzQXl/lines"
                //     },
                //     "livemode": false,
                //     "metadata": [],
                //     "next_payment_attempt": null,
                //     "number": "147D6D20-0024",
                //     "on_behalf_of": null,
                //     "paid": true,
                //     "paid_out_of_band": false,
                //     "payment_intent": "pi_3QwvQYQP5E7ERO2n14LoLCZX",
                //     "payment_settings": {
                //         "default_mandate": null,
                //         "payment_method_options": null,
                //         "payment_method_types": null
                //     },
                //     "period_end": 1740617894,
                //     "period_start": 1740617894,
                //     "post_payment_credit_notes_amount": 0,
                //     "pre_payment_credit_notes_amount": 0,
                //     "quote": null,
                //     "receipt_number": null,
                //     "rendering": null,
                //     "shipping_cost": null,
                //     "shipping_details": null,
                //     "starting_balance": 0,
                //     "statement_descriptor": null,
                //     "status": "paid",
                //     "status_transitions": {
                //         "finalized_at": 1740617894,
                //         "marked_uncollectible_at": null,
                //         "paid_at": 1740617894,
                //         "voided_at": null
                //     },
                //     "subscription": "sub_1QwvQYQP5E7ERO2n1SnOimja",
                //     "subscription_details": {
                //         "metadata": []
                //     },
                //     "subtotal": 24900,
                //     "subtotal_excluding_tax": 24900,
                //     "tax": null,
                //     "test_clock": null,
                //     "total": 24900,
                //     "total_discount_amounts": [],
                //     "total_excluding_tax": 24900,
                //     "total_pretax_credit_amounts": [],
                //     "total_tax_amounts": [],
                //     "transfer_data": null,
                //     "webhooks_delivered_at": 1740617894
                // }
            ],
            fields: [
                // { key: 'account_name', label: 'Nombre de Empresa' },
                { key: 'customer_name', label: 'Usuario' },
                { key: 'id', label: 'ID de Transacción' },
                { key: 'created', label: 'Fecha de Compra', formatter: (value) => new Date(value * 1000).toLocaleDateString() },
                { key: 'amount_paid', label: 'Cantidad', formatter: (value) => `$${(value / 100).toFixed(2)}` },
                // { key: '_', label: ''}
            ]
        };
    },
    methods: {
        viewInvoice({invoice_pdf}) {
            window.open(invoice_pdf, '_blank', 'noopener,noreferrer');
        },
        async loadUp()
        {
            this.isLoaded = false;
        try {
            const response = await axios.get('stripeutils/getinvoices');
            this.invoices = response.data;
        } catch (error) {
            console.error('Error fetching invoices:', error);
        }
        this.isLoaded = true;
        }
    },
    created() {
        this.loadUp()
    }
};
</script>

<style lang="scss">
@import '@/sass/utils/variables.scss';
#usuarioInvoicesStripe {
    .card {
        background-color: $primary-dark;
    }    
    code {
      background: #ededed;
      padding: 4px;
      border-radius: 4px;
    }
}

</style>